import api from '@/core/apiclient'
import {actionTypes, mimeTypes, mutationTypes} from '@/core/constants'
import {DownloadUtils} from '@/core/utils'
const downloadUtils = new DownloadUtils()

export default {
    
    
    async [actionTypes.BUSCAR_PARAMETROS]({commit}, processo) {
        const {data} = await api.licitacao.buscarParametros(processo)
        commit(mutationTypes.SET_PARAMETROS, data)
    },
    
    async [actionTypes.VALIDAR_DOCUMENTO_VIRTUALIZADO](_context, codigo){
        const {data} = await api.validarDocumentoApi.validarDocumento(codigo)
        return {
            valido: data.ehDocumentoValido,
            idVirtualizado: data.documentoVirtualizadoId,
            arquivoSrc: data.arquivoSrc,
            dataHoraValidacao: data.dataHoraPesquisa,
            nome: data.nomeDocumento
        }
    },

    async [actionTypes.BAIXAR_DOCUMENTOS_VIRTUALIZADOS](_context, {id, nome}){
        const {data} = await api.validarDocumentoApi.baixarDocumentos(id)
        let blob = new Blob([data], {
            type: 'application/zip'
        })
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nome ? nome : 'Documentos'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    async [actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO](_context, licitacaoId){
        const {data} = await api.licitacao.baixarAtaPublica(licitacaoId)
        const nomeArquivo = 'Relatorio_da_Ata.pdf'
        downloadUtils.baixarBlob(data, nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.BUSCAR_LICITACOES_PUBLICAS](_context, {filtros, paginacao}){
        const {data} = await api.licitacao.buscarLicitacoesPublicas(filtros, paginacao)
        return data
    },
    
    async [actionTypes.BUSCAR_DADOS_GERAIS]({commit}, licitacaoId){
        const {data} = await api.licitacao.buscarDadosGeraisLicitacao(licitacaoId)
        commit(mutationTypes.SET_LICITACAO, data)
    },
    
    async [actionTypes.BUSCAR_ANEXOS_EDITAL](_context, licitacaoId){
        const {data} = await api.licitacao.buscarAnexosEdital(licitacaoId)
        return data
    },
    
    async [actionTypes.SOLICITAR_ESCLARECIMENTO_IMPUGNACAO](_context, payload){
        const {data} = await api.licitacao.solicitarEsclarecimentoImpugnacaoApi(payload)
        return data
    },
    
    async [actionTypes.VALIDAR_CODIGO_EMAIL](_context, codigo){
        const {data} = await api.licitacao.validarCodigoEmail(codigo)
        return data
    },

    async [actionTypes.BUSCAR_ACOMPANHAMENTO](_context, licitacaoId){
        const {data} = await api.licitacao.buscarAcompanhamentoApi(licitacaoId)
        return data
    },

    async [actionTypes.BUSCAR_ACOMPANHAMENTO_DETALHE](_context, {licitacaoId, loteId}){
        const {data} = await api.licitacao.buscarAcompanhamentoDetalheApi(licitacaoId, loteId)
        return data
    },
    
    async [actionTypes.BUSCAR_ESCLARECIMENTO_IMPUGNACAO](_context, licitacaoId){
        const {data} = await api.licitacao.buscarEsclarecimentosImpugnacoes(licitacaoId)
        Promise.all(data.esclarecimentos.map(async(esclarecimento) => {
            const respostas = await api.licitacao.buscarRespostasEsclarecimentoImpugnacao(esclarecimento.id)
            esclarecimento.respostas = respostas.data.respostas
        })).then((resolvedValues) => {
            resolvedValues.forEach(() => {/* sem retorno */})
        })
        
        Promise.all(data.impugnacoes.map(async(impugnacao) => {
            const respostas = await api.licitacao.buscarRespostasEsclarecimentoImpugnacao(impugnacao.id)
            impugnacao.respostas = respostas.data.respostas
        })).then((resolvedValues) => {
            resolvedValues.forEach(() => {/* sem retorno */})
        })
        return data
    },

    async [actionTypes.BUSCAR_ESTADOS_EFORNECEDOR](){
        const {data} = await api.efornecedor.buscarEstados()
        return data
    },

    async [actionTypes.BUSCAR_MUNICIPIOS_POR_ESTADO](_context, estadoSigla){
        const {data} = await api.licitacao.buscarMunicipios(estadoSigla)
        return data
    },

    async [actionTypes.BUSCAR_PROCESSOS_PUBLICADOS](_context, paginacao){
        const {data} = await api.licitacao.buscarProcessos(paginacao)
        return data
    },

    async [actionTypes.BUSCAR_PROCESSO_LICITACAO](_context, processoId){
        const {data} = await api.licitacao.buscarUnicoProcessoLicitacao(processoId)
        return data
    },

    async [actionTypes.BUSCAR_LOTES_PAGINA_INTERNA](_context, {processoId, paginacao}){
        const {data} = await api.licitacao.buscarLotesPaginaInterna(processoId, paginacao)
        return data
    },

    async [actionTypes.FLOWBEE.BAIXAR_ARQUIVO](context, { payload, headers }){
        const {data} = await api.licitacao.baixarArquivo(payload, headers)

        downloadUtils.baixarBlob(data, payload.nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.GERAR_XML_PROPOSTA_PRESENCIAL](_context, payload){
        const {data} = await api.licitacao.gerarXMLPropostaPresencial(payload)

        downloadUtils.baixarBlob(data, 'proposta.xml', mimeTypes.xml.valor)
    },

    async [actionTypes.BUSCAR_LISTAGEM_SIMULAR_PROPOSTA](_context, licitacaoId){
        const {data} = await api.licitacao.buscarListagemSimularProposta(licitacaoId)
        return data
    },
}
